import React, {useContext} from 'react';
import {SystemManager_API} from "../../SystemManager.API";
import {useParams} from "react-router-dom";
import LinkCell3 from "../../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import MedcenterListPageTemplate from "../../../../components/Templates/MedcenterListPageTemplate";
import {AuthContext} from "../../../../context/AuthContext";

function VerCanterAllOrganizations() {
    const {getAllOrganizationsByVerifyId} = SystemManager_API.counterAgents.verificationCenter
    const {verCenterId, verCenterName} = useParams()
    const {REACT_APP_URL_PREFIX} = process.env
    const {token} = useContext(AuthContext)

    const breadCrumbsItems = [
        {title: 'Контрагенты'},
        {title: 'Удостоверяющие центры',  link: process.env.REACT_APP_URL_PREFIX + `/counterAgents/verificationCenters`},
        {title: verCenterName, actual: true},
    ]

    const linkCell = props => {
        const role = props.idArr[1]
        const toMedCenter = REACT_APP_URL_PREFIX + `/counterAgents/verificationCenters/${verCenterId}/${verCenterName}/medCentres/${props.idArr[0]}/${props.cellContent}/organizations`
        const toHistory = REACT_APP_URL_PREFIX + `/counterAgents/organizations/${props.idArr[0]}/${verCenterId}/${props.cellContent}/history`
        return <LinkCell3 linkRoute={role === "Медцентр" ? toMedCenter : toHistory}
                          linkTitle={props.cellContent}
                          editClick={_ => props.cellData.onClick(props.idArr[0])}/>
    }

    tableModel.haveToShow[0].typeData.cell = linkCell

    return (
        <MedcenterListPageTemplate
            getOrgListAPI={getAllOrganizationsByVerifyId(verCenterId).api}
            tableModel={tableModel}
            breadCrumbsItems={breadCrumbsItems}
            addOrgIsShow={false}
            addOrgAPI={`/api/v1/systemManager/verificationCenters/${verCenterId}/medicalCenters`}
            roleIs={4}/>
    );
}

export default VerCanterAllOrganizations;


var tableModel = {
    firstRow: [
        {title: 'Название', id: 'name'},
        {title: 'Количество людей', id: ''},  // Сортировка не добавлена
        {title: 'Количество организаций', id: ''},  // Сортировка не добавлена
        {title: 'Вид организации', id: ''},
        {title: 'Вызов', id: ''},  // Сортировка не добавлена
    ],
    haveToShow: [
        {id: 'name', idArr: ['org_id', 'type'], type: 'wrapperCell', typeData: {cell: () => {}}},
        {id: 'patients_count'},
        {id: 'org_count'},
        {id: 'type'},
        {id: 'invite_count'},
    ],
}
